import { Alert, Button, Drawer, Form, Skeleton, Space } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { SearchQuery } from 'packages/omnitag/state';
import { useGetFiltersListAPI } from 'packages/omnitag/api/use-get-filters-api';
import {
  FiltersForm,
  SearchQueryForm,
} from 'packages/omnitag/text-search/filters-form';

dayjs.extend(utc); // UTC is a plugin that doesn't come with dayjs by default

export const FiltersPanel = ({
  defaultSearchTerm,
  open,

  onClose,
}: {
  defaultSearchTerm: SearchQuery;
  open: boolean;
  onClose: () => void;
}): JSX.Element => {
  const [form] = Form.useForm<SearchQueryForm | Record<string, unknown>>();
  const filtersSWR = useGetFiltersListAPI();

  return (
    <Drawer
      title="Filters"
      placement="right"
      onClose={onClose}
      open={open}
      size="large"
      extra={
        <Space>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="primary"
            htmlType="submit"
            onClick={(): void => form.submit()}
          >
            Update Search
          </Button>
        </Space>
      }
    >
      {filtersSWR.data && (
        <FiltersForm
          dynamicFilters={filtersSWR.data?.filters ?? []}
          form={form}
          defaultSearchTerm={defaultSearchTerm}
          onClose={onClose}
        />
      )}
      {filtersSWR.isLoading && (
        <Skeleton active title={false} paragraph={{ rows: 24 }} />
      )}
      {filtersSWR.error && (
        <Alert
          message={`Could not load filters. ${filtersSWR.error?.message ?? ''}`}
          type="error"
        />
      )}
    </Drawer>
  );
};
